export const ROLE_ORDER = [
    'sysadmin',
    'admin',
    'manager',
    'advisor',
    'technician',
    'customer',
];
